import { useSyncExternalStore } from 'react'

export type ToastKind = 'error' | 'info' | 'success'

export type Toast = {
  id: number
  kind: ToastKind
  text: string
}

let toasts: Toast[] = []
let nextId = 1
const listeners = new Set<() => void>()

function emit(next: Toast[]): void {
  toasts = next
  for (const listener of listeners) listener()
}

export function pushToast(kind: ToastKind, text: string, ttlMs = 6000): number {
  const id = nextId++
  emit([...toasts, { id, kind, text }])
  window.setTimeout(() => dismissToast(id), ttlMs)
  return id
}

export function dismissToast(id: number): void {
  if (!toasts.some((t) => t.id === id)) return
  emit(toasts.filter((t) => t.id !== id))
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

function getSnapshot(): Toast[] {
  return toasts
}

export function useToasts(): Toast[] {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}
